
export default {
  name: 'vuetify-json-forms-wrapper',
  data() {
    return {
      location: './js/vuetify-json-forms.min.js',
      loading: true,
      error: undefined,
    };
  },
  methods: {
    loadVuetifyJsonForms() {
      this.$loadScript(this.location)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
        });
    },
  },
  mounted() {
    this.loadVuetifyJsonForms();
  },
};
